<template>
  <v-container>
    <v-card align="justify">
      <v-card-title class="headline primary white--text">
      </v-card-title>
      <v-card-text class="black--text">
        <v-row>
          <v-flex xs12>
            <v-img
                class="centrado ml-4 mr-4 mt-3 mb-3"
                :src="require('../../assets/residencial_mx.png')"
                height="250px"
                contain
            ></v-img>
          </v-flex>
        </v-row>
        <br>
        <div class="text-center"><h1>CLUB CAMPESTRE DE SAN LUIS, S.C.P.A<br>AVISO DE PRIVACIDAD</h1></div>
        <br>
        <div><h2>RESPONSABLE DEL TRATAMIENTO DE DATOS PERSONALES</h2></div>
        <br>
        <div class="body-2">
          <strong>CLUB CAMPESTRE DE SAN LUIS, S.C.P.A (EL CLUB)</strong> con domicilio en Prolongación Albino García Número 1035, fraccionamiento Potosino de Golf,
          San Luis Potosí, S.L.P, es responsable del tratamiento de sus datos personales acorde a este aviso de privacidad y de conformidad a lo establecido por los
          artículos 3 fracción 1, 7, 15, 16 y 17 y demás relativos aplicables de Ley Federal de Protección de Datos Personales en Posesión de Particulares.
        </div>
        <br>
        <div><h2>FINALIDAD DEL TRATAMIENTO DE DATOS PERSONALES</h2></div>
        <br>
        <div class="body-2">
          Los Datos Personales del titular de la acción, así como de sus dependientes, en posesión de <strong>EL CLUB</strong> serán utilizados para:<br><br>
          Identificación y verificación para acceso a <strong>EL CLUB</strong>.<br>
          Informe, Invitación y/o inscripción de actividades y torneos de EL CLUB.<br>
          Realizar encuestas y calidad de nuestros servicios.<br>
          Elaboración de los contratos privados de la prestación de servicios.<br>
          Control de las acciones para determinar el tipo y categoría de los usuarios.<br>
          Emitir facturas por cuotas y servicios.<br>
          Confirmar horarios de servicios y/o actividades.<br>
          Dar a conocer e informar de cualquier asunto relacionado con su acción y/o estatus de socio.<br>
          Llevar a cabo el procedimiento establecido por el reglamento interior de <strong>EL CLUB</strong> para la aplicación de sanciones.<br>
          Cualquier otra actividad relacionada con el objeto social que se encuentre contemplada en el reglamento, estatutos sociales y cualquier otra disposición de <strong>EL CLUB</strong>.<br><br>
          Se podrán recabar fotografías del titular y sus dependientes para la emisión de credenciales que permitirá identificarlos como socios de <strong>EL CLUB</strong> así como
          para el registro en alguna asociación deportiva a nivel estatal o federal.<br><br>
          Toda vez que <strong>EL CLUB</strong> fomenta las actividades deportivas y culturales a través de la impartición de clases, torneos, competencias, cursos de verano, eventos
          recreativo, recabando fotografías, imágenes o videos de dichos eventos para difundirlos a los usuarios deportivos a través de carteles, imágenes en pantallas,
          revistas, periódicos, Facebook, Twitter, página de internet y otros medios de difusión.<br><br>
          Para las finalidades antes mencionadas, requerimos obtener los siguientes datos personales del titular de la acción así como de sus dependientes: Nombre
          completo, sexo, fecha de nacimiento, domicilio, teléfono, identificación, RFC y cuenta de correo electrónico.<br><br>
          Nos comprometemos a que su información personal o sensible será trabajada bajo medidas de seguridad, siempre garantizando su confidencialidad.<br>
        </div>
        <br>
        <div><h2>LIMITACIÓN DE USO Y DIVULGACIÓN DE DATOS PERSONALES</h2></div>
        <br>
        <div class="body-2">
          Para imitar el uso de sus datos personales, favor de enviar notificación por escrito a <strong>EL CLUB</strong> con domicilio en Prolongación Albino García Número 1035,
          Fraccionamiento Potosino de Golf, San Luis Potosí, S.L.P. dirigida al Departamento de Datos Personales en el que señale la limitación al uso de sus datos
          deseada.
        </div>
        <br>
        <div><h2>MEDIOS PARA EJERCER DERECHOS DE ARCO (ACCESO, RECTIFICACIÓN, CANCELACIÓN Y OPOSICIÓN)</h2></div>
        <br>
        <div class="body-2">
          Usted tiene derecho de Acceder, Rectificar y/o Cancelar sus datos personales, así como de Oponerse al tratamiento o divulgación de los mismos y/o limitar o
          revocar el consentimiento que para tal fin nos haya otorgado. Para tal efecto, se puede poner en contacto con nuestro Departamento de Datos Personales, que
          tiene su domicilio en prolongación Albino García número 1035, Fraccionamiento Potosino de Golf, San Luis Potosí, S.L.P. y teléfono (444) 813-0608,
          misma que deberá contener por lo menos: a).- nombre y domicilio u otro medio para comunicarle la respuesta a su solicitud. b).- los documentos que acrediten
          su identidad o, en su caso, la representación legal, así como la debida acreditación de su calidad de socio. c).- la descripción clara y precisa de los datos
          personales respecto de los que se solicita ejercer alguno de los derechos ARCO. d).- la manifestación expresa para revocar su consentimiento al tratamiento
          de sus datos personales y por tanto, para que no se usen. e).- cualquier otro elemento que facilite la localización de los datos personales.
        </div>
        <br>
        <div><h2>TRANSPARENCIA</h2></div>
        <br>
        <div class="body-2">
          Así mismo le informamos que sus datos personales no podrán ser transferidos y/o tratados por personas distintas a <strong>EL CLUB</strong>.<br><br>
          No somos responsables por la veracidad de la información personal que usted proporcione ni de su verificación y/o actualización, por lo que si usted no solicita
          el cambio o modificación de información deberá asumirse que la información es precisa y verdadera con todas las implicaciones que esto conlleva, siendo usted
          el único responsable por la información personal proporcionada y sus consecuencias.<br><br>
          En cualquier caso, en la recolección y tratamiento de datos que usted nos proporcione, cumplimos todos los principios que marca la ley: licitud, calidad,
          consentimiento, información, finalidad, lealtad, proporcionalidad y responsabilidad.
        </div>
        <br>
        <div><h2>COOKIES Y PROTOCOLO DE SEGURIDAD EN LÍNEA</h2></div>
        <br>
        <div class="body-2">
          En el momento en el que <strong>EL CLUB</strong> cuente con una página de internet, el titular (usuario) que llegará a tener acceso a la página, conviene en recibir los archivos
          que les transmitan los servidores de <strong>EL CLUB</strong> “Cookie” significa un archivo de datos que se almacena en el disco duro de la computadora del Usuario cuando
          éste tiene acceso a la Página. Dichos archivos pueden contener información tal como la identificación proporcionada por el Usuario o información para rastrear
          las páginas que el Usuario ha visitado. Una cookie no puede leer los datos o páginas.
        </div>
        <br>
        <div><h2>CAMBIOS AL PRESENTE AVISO DE PRIVACIDAD</h2></div>
        <br>
        <div class="body-2">
          El presente Aviso de Privacidad podrá ser modificado en el futuro. En todo caso, cualquier modificación al mismo se hará de su consentimiento mediante el
          envío de un correo electrónico a la cuenta que usted nos proporcionó inicialmente para hacer de su consentimiento el presente Aviso de Privacidad y/o
          mediante la publicación del mismo en la siguiente página web:<br><br>
          <a href="https://clubcampestresanluis.com/" target="_blank">www.clubcampestresanluis.com</a><br><br>
          No seremos responsables en el caso de que usted no reciba la referida notificación de cambio en el Aviso de Privacidad por causa de algún problema con su
          cuenta de correo electrónico o de transmisión de datos por internet. Sin embargo por su seguridad, el Aviso de Privacidad vigente estará disponible en todo
          momento en las oficinas dentro de las instalaciones de <strong>EL CLUB</strong> y/o en la página web señalada.<br><br>
          Fecha de la última actualización 31 de Diciembre de 2013.
        </div>
        <br>
        <div class="text-center" style="font-size:12px;">
          <strong>CLUB CAMPESTRE DE SAN LUIS</strong><br>
          Prol. Albino García #1035, Fracc. Potosino de Golf, C.P. 78150<br>
          San Luis Potosí, S.L.P., México
        </div>
        <br>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'notice_privacy_club'
}
</script>

<style scoped>

</style>
